module.exports = new __parcel__URL__("epa-coal-mines--cover.fb469773.jpg").toString();